import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=7a5647d7&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "@/tbs/stylesheet/dynamic.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "@/tbs/stylesheet/iconfont.css?vue&type=style&index=1&prod&lang=css&"
import style2 from "./BasicInfo.vue?vue&type=style&index=2&id=7a5647d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5647d7",
  null
  
)

export default component.exports